import { createContext, useContext, useState } from "react";
const UserContextWrapper = createContext();

export const useUser = () => {
    return useContext(UserContextWrapper);
};

export function UserProvider({ children }) {
    const [user, setUser] = useState(null);
    return (
        <UserContextWrapper.Provider value={{ user, setUser }}>
            {children}
        </UserContextWrapper.Provider>
    );
}
